import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-consent-history',
  templateUrl: './consent-history.component.html',
  styleUrls: ['./consent-history.component.scss']
})
export class ConsentHistoryComponent implements OnInit {

  breadcrumb: { "label": string; "link": any[]; }[] = [];
  consentHistoryData: any;

  clickEnabledExcludeStates = ['DECLINED']

  constructor(
    private route: Router,
    private httpService: HttpService,
  ) { }

  ngOnInit() {
    this.setBreadcrumb();

    this.getFilteredHistory({});
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "Consent History", "link": ["http://google.com"] },
    ];
  }


  getFilteredHistory(filterParams) {
    let options = {
      type :'post',
      url  :'consentHistory',
      includeUserSession: true,
      data: filterParams
    }
    this.httpService.makeHttpRequest(options).subscribe((res)=>{
      this.consentHistoryData = res;
    });
  }

  isClickEnabled(consentInfo) {
    return !this.clickEnabledExcludeStates.includes(consentInfo.status);
  }


  gotoConsentDetails(consentInfo) {
    if(this.isClickEnabled(consentInfo)) {
      let consentEventId = consentInfo.eventID;

      if(consentInfo.status == 'PENDING') {
        this.route.navigate(['/consent-confirm/consentRequests/' + consentEventId]);
      } else {
        this.route.navigate(['/consent-confirm/activeConsentRecords/' + consentEventId]);
      }
    }
  }
}
